import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=4ab4c13b"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=4ab4c13b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports